export const OBJECT = 'OBJECT';
export const ASSOCIATION = 'ASSOCIATION';